export default {
  name: "toggle_off",
  svg: `<path d="M16 0H6C2.69 0 0 2.69 0 6C0 9.31 2.69 12 6 12H16C19.31 12 22 9.31 22 6C22 2.69 19.31 0 16 0ZM16 10H6C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2H16C18.21 2 20 3.79 20 6C20 8.21 18.21 10 16 10ZM6 3C4.34 3 3 4.34 3 6C3 7.66 4.34 9 6 9C7.66 9 9 7.66 9 6C9 4.34 7.66 3 6 3Z" fill="fillcolor"/>`,
};
